import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Heart, ShieldCheck, Sparkles } from "lucide-react";
import PlayStoreButton from "@/components/PlayStoreButton";

const VALUE_ICONS = [Heart, ShieldCheck, Sparkles];

const About = () => {
  const { t } = useLanguage();
  return (
    <main data-testid="about-page" className="pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-10">
        <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
          {t.about.eyebrow}
        </span>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-blue-950 leading-[1.0]">
          {t.about.title}
        </h1>
        <p className="mt-7 text-lg sm:text-xl text-slate-700 leading-relaxed">
          {t.about.lead}
        </p>

        <div className="mt-10 space-y-6 text-base sm:text-lg text-slate-600 leading-relaxed">
          <p>{t.about.p1}</p>
          <p>{t.about.p2}</p>
          <p>{t.about.p3}</p>
        </div>

        <div className="mt-16">
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-blue-950">
            {t.about.valuesTitle}
          </h2>
          <div className="mt-7 grid grid-cols-1 md:grid-cols-3 gap-5">
            {t.about.values.map((v, i) => {
              const Icon = VALUE_ICONS[i];
              return (
                <div
                  key={v.title}
                  className="card-lift bg-white border border-blue-900/10 rounded-2xl p-6"
                >
                  <div className="h-12 w-12 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-blue-950">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-16 rounded-3xl bg-blue-950 text-white p-8 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-extrabold tracking-tight">
              {t.finalCta.title.split(".")[0]}.
            </h3>
            <p className="text-slate-300 mt-2 text-sm">
              {t.common.freeTrial} · {t.common.tagline}
            </p>
          </div>
          <PlayStoreButton size="lg" variant="light" testId="about-cta-playstore" />
        </div>
      </div>
    </main>
  );
};

export default About;
